interface UserPayload {
  username: Nullable<string>;
  userId: Nullable<string>;
  roles: Nullable<string[]>;
}

export enum AppActions {
  USER_LOGGED_IN = 'USER_LOGGED_IN',
  USER_LOGGED_OUT = 'USER_LOGGED_OUT',
  SET_USERNAME = 'SET_USERNAME',
  SET_COMPONENT_VISIBILITY = 'SET_COMPONENT_VISIBILITY',
}

export type AppAction =
  | {
      type: AppActions.USER_LOGGED_IN;
      payload: UserPayload;
    }
  | {
      type: AppActions.USER_LOGGED_OUT;
    }
  | {
      type: AppActions.SET_USERNAME;
      payload: string;
    }
  | {
      type: AppActions.SET_COMPONENT_VISIBILITY;
      payload: [string, boolean];
    };

const setComponentVisibility = (name: string, visible: boolean): AppAction => ({
  payload: [name, visible],
  type: AppActions.SET_COMPONENT_VISIBILITY,
});

export const appActions = {
  setComponentVisibility,
};
